/** @file rotateGizmo: the rotate tool's three axis rings and the screen-space silhouette (free) ring. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { GizmoShape } from './gizmoShape';
import { unitRing } from './unitRing';

/**
 * Ring `k` lies in the plane of the next two axes (`cos t e_(k+1) + sin t e_(k+2)`, radius 1) and turns about axis
 * `k`; the silhouette ring (handle 3) is the rings' sphere outline on screen, `silhouette` = `[major, minor, angle]`
 * (`silhouetteOf`; a unit circle without display stretch), in the view plane, turning about the view direction.
 */
export function rotateGizmo(silhouette: readonly [number, number, number] = [1, 1, 0]): GizmoShape[] {
  const rings = ([0, 1, 2] as const).map((axis): GizmoShape => ({
    axis, frame: 'axes', lines: [unitRing((axis + 1) % 3, (axis + 2) % 3, 1)], quads: [],
  }));
  const [a, b, t] = silhouette;
  const [c, s] = [Math.cos(t), Math.sin(t)];
  const outline = unitRing(0, 1, 1).map(([x, y]): Vec3 => [a * x * c - b * y * s, a * x * s + b * y * c, 0]);
  return [...rings, { axis: 3, frame: 'screen', lines: [outline], quads: [] }];
}
